/** UI locales supported in Phase 0 (spec §2). Keep in sync with `localeSchema` in @apis/contracts. */
export const LOCALES = ['en', 'id'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

/**
 * BCP 47 tag used for `Intl` formatting. The product's restaurants operate in Indonesia,
 * so English uses the `en-ID` conventions (Rp, `1.250.000`, day-first dates) and
 * Indonesian uses `id-ID`.
 */
export function intlLocale(locale: Locale): string {
  return locale === 'id' ? 'id-ID' : 'en-ID';
}
